import React from 'react';
import Icon from '../../../components/AppIcon';

const QuotationStats = ({ quotations }) => {
  const calculateStats = () => {
    const total = quotations.length;
    const draft = quotations.filter(q => q.status === 'draft').length;
    const sent = quotations.filter(q => q.status === 'sent').length;
    const approved = quotations.filter(q => q.status === 'approved').length;
    const expired = quotations.filter(q => q.status === 'expired').length;
    
    const totalValue = quotations.reduce((sum, q) => sum + q.total, 0);
    const approvedValue = quotations
      .filter(q => q.status === 'approved')
      .reduce((sum, q) => sum + q.total, 0);
    
    const conversionRate = sent > 0 ? (approved / sent * 100) : 0;
    
    return {
      total,
      draft,
      sent,
      approved,
      expired,
      totalValue,
      approvedValue,
      conversionRate
    };
  };

  const stats = calculateStats();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  const statCards = [
    {
      title: 'Total Presupuestos',
      value: stats.total,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary-50'
    },
    {
      title: 'Aprobados',
      value: stats.approved,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success-50'
    },
    {
      title: 'Enviados',
      value: stats.sent,
      icon: 'Send',
      color: 'text-primary',
      bgColor: 'bg-primary-50'
    },
    {
      title: 'Tasa Conversión',
      value: `${stats.conversionRate.toFixed(1)}%`,
      icon: 'TrendingUp',
      color: 'text-accent',
      bgColor: 'bg-accent-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards.map((card, index) => (
        <div key={index} className="bg-surface rounded-lg border border-border p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-text-muted mb-1">
                {card.title}
              </p>
              <p className="text-2xl font-semibold text-text-primary">
                {card.value}
              </p>
            </div>
            <div className={`p-3 rounded-lg ${card.bgColor}`}>
              <Icon name={card.icon} size={24} className={card.color} />
            </div>
          </div>
        </div>
      ))}
      
      {/* Value Cards */}
      <div className="bg-surface rounded-lg border border-border p-4 sm:col-span-2">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium text-text-primary">
            Valor Total
          </h3>
          <Icon name="Euro" size={20} className="text-primary" />
        </div>
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-sm text-text-muted">Total Presupuestado:</span>
            <span className="text-sm font-medium text-text-primary">
              {formatCurrency(stats.totalValue)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-text-muted">Valor Aprobado:</span>
            <span className="text-sm font-medium text-success">
              {formatCurrency(stats.approvedValue)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationStats;